"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var HorizontalRulePreview = function HorizontalRulePreview(_ref) {
  var _ref$content$attrs = _ref.content.attrs,
      color = _ref$content$attrs.color,
      thickness = _ref$content$attrs.thickness,
      classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.hr
  }, "\xA0");
};

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    hr: {
      background: function background(_ref2) {
        var attrs = _ref2.content.attrs;
        return attrs.color ? attrs.color : "#11181e";
      },
      lineHeight: function lineHeight(_ref3) {
        var attrs = _ref3.content.attrs;
        return parseInt(attrs.thickness) ? "".concat(attrs.thickness, "px !important") : "2px !important";
      },
      fontSize: function fontSize(_ref4) {
        var attrs = _ref4.content.attrs;
        return parseInt(attrs.thickness) ? "".concat(attrs.thickness, "px !important") : "2px !important";
      },
      height: function height(_ref5) {
        var attrs = _ref5.content.attrs;
        return parseInt(attrs.thickness) ? "".concat(attrs.thickness, "px") : "2px";
      },
      margin: "0 auto",
      minWidth: "25px"
    }
  };
})(HorizontalRulePreview);

exports["default"] = _default;